module.exports = __webpack_public_path__ + "static/media/gucci.cabd1084.png";